import store from '../store/index'
export default class lsSync {
  static syncData () {
    const userToken = localStorage.getItem('userToken')
    const botId = localStorage.getItem('botId')
    let userData = localStorage.getItem('userData')
    let roleId = parseInt(localStorage.getItem('roleId'))
    let currentRoute = localStorage.getItem('currentRoute')
    let accessToken = localStorage.getItem('accessToken')
    let tableNumberOfRows = localStorage.getItem('tablesNumberOfRows')
    if (tableNumberOfRows === null || tableNumberOfRows === 'null' || tableNumberOfRows === '') {
      tableNumberOfRows = 25
    }
    if (userData) {
      userData = JSON.parse(userData)
      store.dispatch('setUserData', userData)
    }
    store.dispatch('setUserToken', userToken)
    store.dispatch('setBotId', botId)
    store.dispatch('setRoleId', roleId)
    store.dispatch('setCurrentRoute', currentRoute)
    store.dispatch('setAccessToken', accessToken)
    store.dispatch('setTableNumberOfRows', tableNumberOfRows)
  }
}
